let isFontRegistered = false;

export const downloadTextPdf = async (text: string, fileName: string) => {
    const [{ default: pdfMake }, { default: pdfFonts }] = await Promise.all([
        import('pdfmake/build/pdfmake'),
        import('pdfmake/build/vfs_fonts'),
    ]);

    if (!isFontRegistered) {
        pdfMake.addVirtualFileSystem(pdfFonts);
        isFontRegistered = true;
    }

    await pdfMake
        .createPdf({
            content: [
                {
                    color: '#302a36',
                    fontSize: 12,
                    lineHeight: 1.5,
                    text,
                },
            ],
            defaultStyle: {
                font: 'Roboto',
            },
            info: {
                title: fileName,
            },
            pageMargins: [48, 48, 48, 48],
            pageSize: 'A4',
        })
        .download(fileName);
};
